module.exports = __webpack_public_path__ + "img/icon-capsule.83b73328.svg";